module.exports = __webpack_public_path__ + "img/balanceBg_59775.png";